import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import Table from "../../../../../core/pagination/datatable.jsx";
import { Select, Spin } from "antd";
import {
  ROLL_CALL_API_BASE_URL,
  ROLL_CALL_GET_MY_TEAM,
  ROLL_CALL_GET_TEAM_ATTENDANCE,
} from "../../RollCallConfig/RollCallConfig.js";
import { DatePicker } from "antd";
import dayjs from "dayjs";
import jsPDF from "jspdf";
import "jspdf-autotable";
import * as XLSX from "xlsx";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import { RotateCcw } from "feather-icons-react/build/IconComponents";
import ImageWithBasePath from "../../../../../core/img/imagewithbasebath";
import CommonFooter from "../../../../../core/common/footer/commonFooter.jsx";

const { RangePicker } = DatePicker;

const TeamAttendance = () => {
  const today = dayjs();
  const tenDaysBefore = today.subtract(10, "day");

  const [attendance, setAttendance] = useState([]);
  const [teamMembers, setTeamMembers] = useState([]);
  const [selectedEmp, setSelectedEmp] = useState("");
  const [tokenData, setTokenData] = useState(null);
  const [superIdData, setSuperIdData] = useState(null);
  const [loading, setloading] = useState(false);
  const [startDate, setStartDate] = useState(
    tenDaysBefore.format("YYYY-MM-DD")
  );
  const [endDate, setEndDate] = useState(today.format("YYYY-MM-DD"));

  const navigate = useNavigate();
  const userData = JSON.parse(sessionStorage.getItem("userData"));
  const regId = userData?.RegId;

  useEffect(() => {
    const isManager = sessionStorage.getItem("isManager");

    if (isManager === "false") {
      alert("You don't have access to this page.");
      sessionStorage.clear();
      navigate("/signin");
    }
  }, [navigate]);
  const disabledDate = (current) => {
    return current && current > today.endOf("day");
  };

  const handleChange = (dates) => {
    if (dates) {
      setStartDate(dates[0].format("YYYY-MM-DD"));
      setEndDate(dates[1].format("YYYY-MM-DD"));
    }
  };

  useEffect(() => {
    const token = sessionStorage.getItem("authToken");
    const superId = sessionStorage.getItem("superId");

    if (token && superId) {
      setTokenData(token);
      setSuperIdData(superId);
    } else {
      console.warn("User data not found in sessionStorage");
      navigate("/signin");
    }
  }, [navigate]);

  useEffect(() => {
    if (tokenData && superIdData) {
      console.log("Token:", tokenData);
      console.log("SuperId:", superIdData);
    }
  }, [tokenData, superIdData]);

  console.log(attendance);
  const fetchAttendance = () => {
    if (tokenData && superIdData) {
      setloading(true);
      const statusParam = selectedEmp ? `&regid=${selectedEmp}` : "";

      fetch(
        `${ROLL_CALL_API_BASE_URL}${ROLL_CALL_GET_TEAM_ATTENDANCE}?managerid=${regId}&&startdate=${startDate}&enddate=${endDate}${statusParam}`,
        {
          method: "GET",
          headers: { Authorization: `Bearer ${tokenData}` },
        }
      )
        .then((response) => {
          if (!response.ok)
            throw new Error(`HTTP error! Status: ${response.status}`);
          return response.json();
        })
        .then((data) => {
          if (data?.status) {
            setAttendance(data.ResultData || []);
          } else {
            console.error("Invalid data format:", data);
            setAttendance([]);
          }
        })
        .catch((error) => {
          console.error("Error fetching data:", error);
        })
        .finally(() => {
          setloading(false);
        });
    }
  };

  useEffect(() => {
    fetchAttendance(); // Initial fetch
  }, [superIdData, tokenData]);

  useEffect(() => {
    if (tokenData && superIdData) {
      fetch(
        `${ROLL_CALL_API_BASE_URL}${ROLL_CALL_GET_MY_TEAM}?managerid=${regId}`,
        {
          method: "GET",
          headers: { Authorization: `Bearer ${tokenData}` },
        }
      )
        .then((response) => {
          console.log(response);
          if (!response.ok) {
            throw new Error(`HTTP error! Status: ${response.status}`);
          }
          return response.json();
        })
        .then((data) => {
          if (data && data.status) {
            setTeamMembers(data.ResultData || []);
          } else {
            console.error("Invalid data format:", data);
            setTeamMembers([]);
          }
        })
        .catch((error) => {
          console.error("Error fetching data:", error);
        });
    }
  }, [superIdData, tokenData]);

  const columns = [
    {
      title: "Badge",
      dataIndex: "CardId",
      sorter: (a, b) => a.CardId.length - b.CardId.length,
    },
    {
      title: "Name",
      dataIndex: "UserName",
      sorter: (a, b) => a.UserName.length - b.UserName.length,
    },
    {
      title: "Designation",
      dataIndex: "Designation",
      sorter: (a, b) => a.Designation.length - b.Designation.length,
    },
    {
      title: "Department",
      dataIndex: "Dept",
      sorter: (a, b) => a.Dept.length - b.Dept.length,
    },
    {
      title: "Date",
      dataIndex: "DateOfTransaction",
      sorter: (a, b) =>
        new Date(a.DateOfTransaction) - new Date(b.DateOfTransaction),
      render: (date) => new Date(date).toISOString().split("T")[0], // Shows "YYYY-MM-DD"
    },
    {
      title: "Shift",
      dataIndex: "ActualShiftName",
      sorter: (a, b) => a.ActualShiftName?.length - b.ActualShiftName?.length,
      //   align: "center",
      render: (value) => {
        if (!value) return "-";

        const shift = value.toLowerCase();

        let badgeClass = "badge-secondary"; // default
        switch (shift) {
          case "general":
            badgeClass = "badge-success";
            break;
          case "morning":
            badgeClass = "badge-info";
            break;
          case "afternoon":
            badgeClass = "badge-secondary";
            break;
          case "nightshift":
            badgeClass = "badge-primary";
            break;
        }

        return <span className={`badge ${badgeClass} badge-xs`}>{value}</span>;
      },
    },
    {
      title: "Clock In",
      dataIndex: "InTime",
      sorter: (a, b) => a.InTime?.length - b.InTime?.length,
      render: (value) => {
        if (!value) return "-";
        const date = new Date(value);
        const hours = String(date.getUTCHours()).padStart(2, "0");
        const minutes = String(date.getUTCMinutes()).padStart(2, "0");
        return `${hours}:${minutes}`;
      },
    },
    {
      title: "Clock Out",
      dataIndex: "OutTime",
      sorter: (a, b) => a.OutTime?.length - b.OutTime?.length,
      render: (value) => {
        if (!value) return "-";
        const date = new Date(value);
        const hours = String(date.getUTCHours()).padStart(2, "0");
        const minutes = String(date.getUTCMinutes()).padStart(2, "0");
        return `${hours}:${minutes}`;
      },
    },
    {
      title: "In Status",
      dataIndex: "InStCode",
      sorter: (a, b) => a.InStCode?.length - b.InStCode?.length,
      render: (text) => {
        const status = text?.toLowerCase();

        let badgeClass = "badge-secondary"; // default
        switch (status) {
          case "present":
            badgeClass = "badge-success";
            break;
          case "late":
            badgeClass = "badge-warning";
            break;
          case "leave":
          case "absent":
            badgeClass = "badge-danger";
            break;
          case "holiday":
            badgeClass = "badge-primary";
            break;
          case "weekoff":
            badgeClass = "badge-secondary";
            break;
          case "No Swipe":
            badgeClass = "badge-danger";
            break;
        }

        return (
          <span
            className={`badge ${badgeClass} d-inline-flex align-items-center badge-xs`}
          >
            <i className="ti ti-point-filled me-1" />
            {text}
          </span>
        );
      },
    },
    {
      title: "Out Status",
      dataIndex: "OutStCode",
      sorter: (a, b) => a.OutStCode?.length - b.OutStCode?.length,
      render: (text) => {
        const status = text?.toLowerCase();

        let badgeClass = "badge-secondary";
        switch (status) {
          case "present":
            badgeClass = "badge-success";
            break;
          case "late":
            badgeClass = "badge-warning";
            break;
          case "leave":
          case "absent":
            badgeClass = "badge-danger";
            break;
          case "holiday":
            badgeClass = "badge-primary";
            break;
          case "weekoff":
            badgeClass = "badge-secondary";
            break;
          case "No Swipe":
            badgeClass = "badge-danger";
            break;
        }

        return (
          <span
            className={`badge ${badgeClass} d-inline-flex align-items-center badge-xs`}
          >
            <i className="ti ti-point-filled me-1" />
            {text}
          </span>
        );
      },
    },
  ];

  const generatePDF = () => {
    if (!attendance || attendance.length === 0) return;

    const formatDate = (dateString) => {
      if (!dateString) return "N/A";
      return new Date(dateString).toISOString().split("T")[0]; // YYYY-MM-DD
    };

    const formatTime = (timeString) => {
      if (!timeString) return "-";
      const date = new Date(timeString);
      const hours = String(date.getUTCHours()).padStart(2, "0");
      const minutes = String(date.getUTCMinutes()).padStart(2, "0");
      return `${hours}:${minutes}`;
    };

    const doc = new jsPDF();
    doc.text("Attendance Report", 14, 10);

    const tableColumn = [
      "Badge",
      "Name",
      "Designation",
      "Department",
      "Date",
      "Shift",
      "Clock In",
      "Clock Out",
      "In Status",
      "Out Status",
    ];

    const tableRows = attendance.map((item) => [
      item.CardId ?? "N/A",
      item.UserName ?? "N/A",
      item.Designation ?? "N/A",
      item.Dept ?? "N/A",
      formatDate(item.DateOfTransaction),
      item.ActualShiftName ?? "-",
      formatTime(item.InTime),
      formatTime(item.OutTime),
      item.InStCode ?? "-",
      item.OutStCode ?? "-",
    ]);

    doc.autoTable({ head: [tableColumn], body: tableRows, startY: 20 });
    doc.save("Attendance_Report.pdf");
  };

  const handleDownloadExcel = () => {
    if (!attendance || attendance.length === 0) return;

    const formatDate = (dateString) => {
      if (!dateString) return "N/A";
      return new Date(dateString).toISOString().split("T")[0]; // YYYY-MM-DD
    };

    const formatTime = (timeString) => {
      if (!timeString) return "-";
      const date = new Date(timeString);
      const hours = String(date.getUTCHours()).padStart(2, "0");
      const minutes = String(date.getUTCMinutes()).padStart(2, "0");
      return `${hours}:${minutes}`;
    };

    const wsData = attendance.map((item, index) => ({
      "S.No": index + 1,
      Badge: item.CardId ?? "N/A",
      Name: item.UserName ?? "N/A",
      Designation: item.Designation ?? "N/A",
      Department: item.Dept ?? "N/A",
      Date: formatDate(item.DateOfTransaction),
      Shift: item.ActualShiftName ?? "-",
      "Clock In": formatTime(item.InTime),
      "Clock Out": formatTime(item.OutTime),
      "In Status": item.InStCode ?? "-",
      "Out Status": item.OutStCode ?? "-",
    }));

    const wb = XLSX.utils.book_new();
    const ws = XLSX.utils.json_to_sheet(wsData);
    XLSX.utils.book_append_sheet(wb, ws, "Attendance Report");
    XLSX.writeFile(wb, "Attendance_Report.xlsx");
  };

  const renderTooltip = (props) => (
    <Tooltip id="pdf-tooltip" {...props}>
      Pdf
    </Tooltip>
  );
  const renderExcelTooltip = (props) => (
    <Tooltip id="excel-tooltip" {...props}>
      Excel
    </Tooltip>
  );
  const renderRefreshTooltip = (props) => (
    <Tooltip id="refresh-tooltip" {...props}>
      Refresh
    </Tooltip>
  );

  return (
    <div>
      <div className="page-wrapper pt-5">
        <div className="content">
          <div className="page-header">
            <div className="add-item d-flex">
              <div className="page-title">
                <nav aria-label="breadcrumb">
                  <ol className="breadcrumb">
                    <li className="breadcrumb-item">
                      <Link to="/rollcall/dashboard">
                        <i className="fas fa-home fa-lg" />
                      </Link>
                    </li>
                    <h4 className="breadcrumb-item " aria-current="page">
                      Team Attendance
                    </h4>
                  </ol>
                </nav>
                <h6>Track Your Team Attendance</h6>
              </div>
            </div>
            <ul className="table-top-head">
              <li>
                <OverlayTrigger placement="top" overlay={renderTooltip}>
                  <Link onClick={generatePDF}>
                    <ImageWithBasePath
                      src="assets/img/icons/pdf.svg"
                      alt="img"
                    />
                  </Link>
                </OverlayTrigger>
              </li>
              <li>
                <OverlayTrigger placement="top" overlay={renderExcelTooltip}>
                  <Link
                    data-bs-toggle="tooltip"
                    data-bs-placement="top"
                    onClick={handleDownloadExcel}
                  >
                    <ImageWithBasePath
                      src="assets/img/icons/excel.svg"
                      alt="img"
                    />
                  </Link>
                </OverlayTrigger>
              </li>
              <li onClick={() => window.location.reload()}>
                <OverlayTrigger placement="top" overlay={renderRefreshTooltip}>
                  <Link data-bs-toggle="tooltip" data-bs-placement="top">
                    <RotateCcw />
                  </Link>
                </OverlayTrigger>
              </li>
            </ul>
          </div>
          {/* /product list */}
          <div className="card table-list-card">
            <div className="card-header d-flex align-items-center justify-content-between flex-wrap row-gap-3">
             <div className="search-set col-lg-auto col-md-12 mb-md-1 mb-sm-1 mb-lg-0"></div>
          <div className="col-lg-auto col-md-12 mt-md-4 mt-sm-5 mt-lg-0">
              <div className="d-flex table-dropdown my-xl-auto right-content align-items-center flex-wrap row-gap-3">
                <div className="me-2">
                  <RangePicker
                    defaultValue={[tenDaysBefore, today]}
                    disabledDate={disabledDate}
                    onChange={handleChange}
                    style={{ width: 240 }}
                  />
                </div>
                <div className="me-2">
                  <Select
                    style={{ width: 160 }}
                    placeholder="Select a team member"
                    value={selectedEmp}
                    onChange={(value) => {
                      setSelectedEmp(value);
                      console.log("Selected Employee:", value);
                    }}
                    options={[
                      { value: "", label: "All Employees" },
                      ...teamMembers.map((member) => ({
                        value: member.RegId,
                        label: member.UserName,
                      })),
                    ]}
                  />
                </div>
                <div>
                  <button className="btn btn-primary" onClick={fetchAttendance}>
                    <i className="fa-solid fa-magnifying-glass"></i>
                  </button>
                </div>
              </div>
              </div>
            </div>
            <div className="card-body pb-0">
              <div className="table-responsive">
                {loading ? (
                  <div className="text-center my-4">
                    <Spin size="large" />
                    <p>Loading data...</p>
                  </div>
                ) : attendance.length > 0 ? (
                  <Table columns={columns} dataSource={attendance} />
                ) : (
                  <p className="text-center my-4">No data available</p>
                )}
              </div>
            </div>
          </div>
          {/* /product list */}
        </div>
        <CommonFooter />
      </div>
    </div>
  );
};

export default TeamAttendance;
